// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-form-control-error-message {
  color: var(--main-red);
  text-align: left;
  line-height: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: calc(var(--main-font-size-control) * 0.65);
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/Form/components/FormControlError/FormControlError.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qDAAA;AACF","sourcesContent":[".lsn-form-control-error-message {\n  color: var(--main-red);\n  text-align: left;\n  line-height: normal;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: calc(var(--main-font-size-control) * .65);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
